import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Card, CardHeader, CardText} from 'material-ui/Card';
import {
    Table,
    TableHeader,
    TableHeaderColumn,
    TableRow,
    TableRowColumn,
    TableBody
} from "material-ui";
import TransferAuditTableRow from '../components/TransferAuditTableRow';
import FuseTheme from "../global/theme";

/**
 * A component for generating rows of TransferAuditTableRows.
 *
 */
class TransferAuditTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            variances: [],
        };
    }

    componentWillMount() {
        const variances = this.updateVariances(this.props.variances);
        this.setState({
            variances: variances
        });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.variances !== this.props.variances) {
            const variances = this.updateVariances(nextProps.variances);
            this.setState({
                variances: variances
            });
        }
    }

    updateVariances(variancesList) {
        let variances = variancesList;
        if (variances && variances.length) {
            for (let i = 0; i < variances.length; i++) {
                const discrepancy = variances[i].counted - variances[i].original_qty;
                const sign = (discrepancy >= 0) ? '+' : '';
                variances[i].discrepancy = sign + discrepancy.toString();
            }
            return variances;
        }
        return [];
    };

    // Create table rows of Transfer Audit items
    makeTransferAuditTable = (list) => {
        if (!list || !list.length) {
            const styles = {
                columnSmall: {paddingLeft: 10, paddingRight: 10},
            };

            return (
                <TableRow>
                    <TableRowColumn colSpan={3} style={styles.columnSmall}>No Variances</TableRowColumn>
                    <TableRowColumn style={styles.columnSmall}>&nbsp;</TableRowColumn>
                    <TableRowColumn style={styles.columnSmall}>&nbsp;</TableRowColumn>
                    <TableRowColumn style={styles.columnSmall}>&nbsp;</TableRowColumn>
                </TableRow>
            )
        }
        return (
            list.map((item, index) => (
                <TransferAuditTableRow
                    key={item.product_unit.toString() + index}
                    data={item}
                />
            ))
        )
    };

    render() {
        const styles = {
            fieldDescription: {
                display: 'block',
                width: '100%',
                fontSize: '14px',
                color: FuseTheme.palette.lightTextColor,
                margin: '0 0 1em 0',
            },
            tableCard: {display: 'block', margin: '1em 0 0 0'},
            columnSmall: {paddingLeft: 10, paddingRight: 10},
        };

        return (
            <Card style={styles.tableCard} initiallyExpanded>
                <CardHeader title="Transfer Audit Variances" actAsExpander={true} showExpandableButton={true}/>
                <CardText expandable={true}>
                    <span style={styles.fieldDescription}>If there are discrepancies between what was transferred to
                        this Location and what was actually received, they will appear here. If the discrepancy
                        occurred in a Repack or a Retail Box, its ID will be displayed.</span>
                    <Table selectable={false} multiSelectable={false}>
                        <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                            <TableRow>
                                <TableHeaderColumn style={styles.columnSmall}>Item Barcode</TableHeaderColumn>
                                <TableHeaderColumn style={styles.columnSmall}>Name</TableHeaderColumn>
                                <TableHeaderColumn style={styles.columnSmall}>Transfer<br/>Qty</TableHeaderColumn>
                                <TableHeaderColumn style={styles.columnSmall}>Counted<br/>Qty</TableHeaderColumn>
                                <TableHeaderColumn style={styles.columnSmall}>Discrepancy</TableHeaderColumn>
                                <TableHeaderColumn style={styles.columnSmall}>Discrepancy found in<br/>Repack ID/Retail
                                    Box</TableHeaderColumn>
                            </TableRow>
                        </TableHeader>
                        <TableBody displayRowCheckbox={false}>
                            {[...this.makeTransferAuditTable(this.state.variances)]}
                        </TableBody>
                    </Table>
                </CardText>
            </Card>
        )
    }
}

TransferAuditTable.propTypes = {
    variances: PropTypes.array,
};

TransferAuditTable.defaultProps = {
    variances: [],
};

export default TransferAuditTable;


// WEBPACK FOOTER //
// ./src/Fuse/components/TransferAuditTable.js